import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { Voucher, listVouchers } from '~/services/PromoService';

export const voucherQueryKeys = {
  all: ['vouchers'] as const,
  lists: () => [...voucherQueryKeys.all, 'list'] as const,
  byIds: (ids: Array<string>) => [...voucherQueryKeys.lists(), 'by-ids', ids] as const,
};

type Params = {
  voucherIds: Array<string>;
  brand?: string;
  enabled?: boolean;
};

export function useGetVouchersByIds({ voucherIds, brand, enabled = true }: Params) {
  const normalizedIds = useMemo(() => {
    const ids = voucherIds.filter(Boolean);
    return Array.from(new Set(ids)).sort();
  }, [voucherIds]);

  const query = useQuery({
    queryKey: [...voucherQueryKeys.byIds(normalizedIds), brand],
    queryFn: async () => {
      const response = await listVouchers({
        voucher_ids: normalizedIds,
        limit: normalizedIds.length,
        ...(brand ? { brand } : {}),
      });
      const vouchers = response.result?.vouchers ?? [];
      return new Map<string, Voucher>(vouchers.map((v) => [v.voucherId, v]));
    },
    enabled: enabled && normalizedIds.length > 0,
  });

  return query;
}
